import { render, staticRenderFns } from "./Marcas_agregar.vue?vue&type=template&id=af704f4e"
import script from "./Marcas_agregar.vue?vue&type=script&lang=js"
export * from "./Marcas_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports